import { render } from "./ToolExitFullScreenIcon.vue?vue&type=template&id=ba191132"
import script from "./ToolExitFullScreenIcon.vue?vue&type=script&lang=js"
export * from "./ToolExitFullScreenIcon.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__